import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Creates a radio tag, or a category when isCategory is true.
const POST_ADD_RADIO_TAG = gql`
  mutation postAddRadioTag($name: RadioMultilangInput!, $isCategory: Boolean!) {
    postAddRadioTag(name: $name, isCategory: $isCategory) {
      isAuth
      ok
      errors { field message }
      tag { id name { es ca en pt } isCategory usage }
    }
  }
`;

const postAddRadioTag = async ({ name, isCategory }) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_ADD_RADIO_TAG,
        variables: { name, isCategory },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postAddRadioTag: postAddRadioTagData },
    } = result;

    if (postAddRadioTagData) {
      return postAddRadioTagData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postAddRadioTag = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postAddRadioTag Error: ${error}`);
    return null;
  }
};

export default postAddRadioTag;
